<mat-select [(value)]="selectedLocale" (selectionChange)="onLocaleChange()" style="width: 150px;">
  <mat-option *ngFor="let locale of locales" [value]="locale">
    {{locale.name}}
  </mat-option>
</mat-select>